export default "__VITE_ASSET__B5MqSAbT__"